<template>
  <div id="unit-list">
    <section class="py-3 bg-grey">
      <form @submit.stop.prevent="searchProp('')">
        <div class="container d-none d-md-block">
          <div class="row py-3 pt-lg-4 pt-lg-3">
            <div class="col-12">
              <h4 class="mb-4">
                <b>{{ $t("pages.searchUnit") }}</b>
              </h4>
            </div>
            <div class="col">
              <div
                v-bind:class="[
                  dataFilterZone.length != 0
                    ? 'field-search-select'
                    : 'field-search',
                ]"
              >
                <div class="float-left">
                  <b>{{ $t("pages.zone") }}</b>
                </div>
                <div class="float-right">
                  <div class="mr-2 d-inline">
                    {{
                      dataFilterZone.length != 0 ? dataFilterZone.length : ""
                    }}
                  </div>
                  <div class="d-inline">
                    <i class="fas fa-long-arrow-alt-down"></i>
                  </div>
                </div>
                <div class="block-dropdown">
                  <div class="field-search-dropdown">
                    <label
                      class="container-checkbox"
                      v-for="(item, i) in filterZone"
                      :key="`filterZone${i}`"
                    >
                      {{ item["zone_" + $i18n.locale] }}
                      <input
                        type="checkbox"
                        v-model="item.checked"
                        @click="
                          getFilterProjectName(item.zone_Code, !item.checked)
                        "
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div
                v-bind:class="[
                  dataFilterProjectName.length != 0
                    ? 'field-search-select'
                    : 'field-search',
                ]"
              >
                <div class="float-left">
                  <b>{{ $t("pages.project") }}</b>
                </div>
                <div class="float-right">
                  <div class="mr-2 d-inline">
                    {{
                      dataFilterProjectName.length != 0
                        ? dataFilterProjectName.length
                        : ""
                    }}
                  </div>
                  <div class="d-inline">
                    <i class="fas fa-long-arrow-alt-down"></i>
                  </div>
                </div>
                <div class="block-dropdown">
                  <div class="field-search-dropdown">
                    <label
                      class="container-checkbox"
                      v-for="(item, i) in filterProjectName"
                      :key="`filterProjectName${i}`"
                    >
                      {{ item["projectName_" + $i18n.locale] }}
                      <input
                        type="checkbox"
                        v-model="item.checked"
                        @click="getFilterZone(item.project_Code, !item.checked)"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div
                v-bind:class="[
                  dataFillterroomType.length != 0
                    ? 'field-search-select'
                    : 'field-search',
                ]"
              >
                <div class="float-left">
                  <b>{{ $t("pages.roomType") }}</b>
                </div>
                <div class="float-right">
                  <div class="mr-2 d-inline">
                    {{
                      dataFillterroomType.length != 0
                        ? dataFillterroomType.length
                        : ""
                    }}
                  </div>
                  <div class="d-inline">
                    <i class="fas fa-long-arrow-alt-down"></i>
                  </div>
                </div>
                <div class="block-dropdown">
                  <div class="field-search-dropdown">
                    <label
                      class="container-checkbox"
                      v-for="(item, i) in roomType"
                      :key="`roomType${i}`"
                    >
                      {{ item["listName_" + $i18n.locale] }}
                      <input
                        type="checkbox"
                        v-model="item.checked"
                        @click="
                          getFilterRoomType(item.room_Code, !item.checked)
                        "
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div
                v-bind:class="[
                  formSearch.fromPrice != '' || formSearch.toPrice != ''
                    ? 'field-search-select'
                    : 'field-search',
                ]"
              >
                <div class="float-left">
                  <b>{{ $t("pages.price") }}</b>
                </div>
                <div class="float-right">
                  <!-- <div class="mr-2 d-inline">{{getPriceList.length}}</div> -->
                  <div class="d-inline">
                    <i class="fas fa-long-arrow-alt-down"></i>
                  </div>
                </div>
                <div class="block-dropdown">
                  <div class="field-search-dropdown">
                    <!-- <b-form-group>
                      <b-form-radio-group id="price" v-model="formSearch.price" name="price">
                        <b-form-radio
                          :value="item.list_Code"
                          v-for="(item, i) in getPriceList"
                          :key="i"
                          class="pl-0 w-100"
                        >{{item['listName_'+$i18n.locale]}}</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group> -->
                    <div class="float-left" style="width: 45%">
                      <input
                        type="number"
                        class="form-control"
                        v-model="formSearch.fromPrice"
                      />
                    </div>
                    <div class="float-left text-center" style="width: 10%">
                      -
                    </div>
                    <div class="float-left" style="width: 45%">
                      <input
                        type="number"
                        class="form-control"
                        v-model="formSearch.toPrice"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <button class="btn btn-primary py-1 w-100" type="submit">
                {{ $t("button.search") }}
              </button>
            </div>
            <div class="col-12 mt-4">
              <div class="border-bottom border-white"></div>
              <div class="border-bottom"></div>
            </div>
            <div class="col-12 mt-4 mb-3">
              <div class="more-filter cursor-pointer d-inline">
                <div class="d-inline mr-2">
                  <b
                    v-bind:class="[
                      filterFloor.filter((value) => value.checked == true)
                        .length > 0 ||
                      filterFacing.filter((value) => value.checked == true)
                        .length > 0 ||
                      filterRoomAmenities.filter(
                        (value) => value.checked == true
                      ).length > 0 ||
                      filterProjectFacilities.filter(
                        (value) => value.checked == true
                      ).length > 0 ||
                      formSearch.fromArea != '' ||
                      formSearch.toArea != ''
                        ? 'text-blue'
                        : 'text-grey',
                    ]"
                    >{{ $t("pages.moreFilter") }}</b
                  >
                </div>
                <div class="d-inline">
                  <img src="./../../assets/images/icon/plus.png" />
                </div>
                <div class="more-filter-dropdown">
                  <div
                    class="list"
                    :class="{
                      active:
                        filterFloor.filter((value) => value.checked == true)
                          .length > 0,
                    }"
                  >
                    {{ $t("pages.floor") }}
                    <div class="float-right">
                      {{
                        filterFloor.filter((value) => value.checked == true)
                          .length > 0
                          ? filterFloor.filter((value) => value.checked == true)
                              .length
                          : ""
                      }}
                    </div>
                    <div class="list-filter">
                      <b>{{ $t("pages.floor") }}</b>
                      <label
                        class="container-checkbox"
                        v-for="(item, i) in filterFloor"
                        :key="`${i}`"
                      >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div
                    class="list"
                    :class="{
                      active: formSearch.fromArea || formSearch.toArea,
                    }"
                  >
                    {{ $t("pages.area") }}
                    <div class="list-filter">
                      <div class="w-100">
                        <b>{{ $t("pages.area_s") }}</b>
                      </div>
                      <div class="float-left" style="width: 100px">น้อยสุด</div>
                      <div class="float-right" style="width: 100px">มากสุด</div>
                      <div class="float-left" style="width: 100px">
                        <input
                          class="form-control"
                          v-model="formSearch.fromArea"
                        />
                      </div>
                      <div
                        class="float-left mx-2 text-center"
                        style="width: 45px"
                      >
                        {{ $t("pages.to") }}
                      </div>
                      <div class="float-left" style="width: 100px">
                        <input
                          class="form-control"
                          v-model="formSearch.toArea"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="list"
                    :class="{
                      active:
                        filterFacing.filter((value) => value.checked == true)
                          .length > 0,
                    }"
                  >
                    {{ $t("pages.facing") }}
                    <div class="float-right">
                      {{
                        filterFacing.filter((value) => value.checked == true)
                          .length > 0
                          ? filterFacing.filter(
                              (value) => value.checked == true
                            ).length
                          : ""
                      }}
                    </div>
                    <div class="list-filter">
                      <b>{{ $t("pages.facing") }}</b>
                      <label
                        class="container-checkbox"
                        v-for="(item, i) in filterFacing"
                        :key="`${i}`"
                      >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div
                    class="list"
                    :class="{
                      active:
                        filterRoomAmenities.filter(
                          (value) => value.checked == true
                        ).length > 0,
                    }"
                  >
                    {{ $t("pages.roomAmenities") }}
                    <div class="float-right">
                      {{
                        filterRoomAmenities.filter(
                          (value) => value.checked == true
                        ).length > 0
                          ? filterRoomAmenities.filter(
                              (value) => value.checked == true
                            ).length
                          : ""
                      }}
                    </div>
                    <div class="list-filter">
                      <b>{{ $t("pages.roomAmenities") }}</b>
                      <label
                        class="container-checkbox"
                        v-for="(item, i) in filterRoomAmenities"
                        :key="`filterZone${i}`"
                      >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div
                    class="list"
                    :class="{
                      active:
                        filterProjectFacilities.filter(
                          (value) => value.checked == true
                        ).length > 0,
                    }"
                  >
                    {{ $t("pages.projectFacilities") }}
                    <div class="float-right">
                      {{
                        filterProjectFacilities.filter(
                          (value) => value.checked == true
                        ).length > 0
                          ? filterProjectFacilities.filter(
                              (value) => value.checked == true
                            ).length
                          : ""
                      }}
                    </div>
                    <div class="list-filter">
                      <b>{{ $t("pages.projectFacilities") }}</b>
                      <label
                        class="container-checkbox"
                        v-for="(item, i) in filterProjectFacilities"
                        :key="`${i}`"
                      >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container d-block d-md-none">
          <div class="row py-3 py-lg-5">
            <div class="col-12">
              <h4>
                <b>{{ $t("pages.searchUnit") }}</b>
              </h4>
              <div class="filter-search">
                <b-button
                  v-b-toggle.filterHome
                  variant="primary"
                  class="w-100 text-left"
                >
                  {{ $t("pages.moreFilter") }}
                  <i class="fas fa-caret-down float-right mt-1"></i>
                </b-button>
                <b-collapse id="filterHome" class="mt-2">
                  <!-- filter mobile -->
                  <b-card>
                    <b-button v-b-toggle.filter1 size="sm" variant="primary" class="w-100 text-left">
                      {{ $t("pages.zone") }}
                      <div class="float-right"> {{ dataFilterZone.length != 0 ? dataFilterZone.length : "" }}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter1" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterZone" :key="`filterZone${i}`">{{ item["zone_" + $i18n.locale] }}
                          <input type="checkbox" v-model="item.checked" @click="getFilterProjectName(item.zone_Code, !item.checked)"/>
                          <span class="checkmark"></span>
                        </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter2 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.project") }}
                      <div class="float-right">{{dataFilterProjectName.length != 0 ? dataFilterProjectName.length : "" }}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter2" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterProjectName" :key="`filterProjectName${i}`">
                          {{ item["projectName_" + $i18n.locale] }}
                          <input type="checkbox" v-model="item.checked" @click="getFilterZone(item.project_Code, !item.checked)"/>
                          <span class="checkmark"></span>
                        </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter3 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.roomType") }}
                      <div class="float-right">{{dataFillterroomType.length != 0 ? dataFillterroomType.length : "" }}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter3" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in roomType" :key="`roomType${i}`">
                          {{ item["listName_" + $i18n.locale] }}
                          <input type="checkbox" v-model="item.checked" @click="getFilterRoomType(item.room_Code, !item.checked)"/>
                          <span class="checkmark"></span>
                        </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter4 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.price") }}
                      <div class="float-right"><i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter4" class="mt-2">
                      <b-card>
                        <div class="float-left" style="width: 45%">
                          <input type="number" class="form-control" v-model="formSearch.fromPrice"/>
                        </div>
                        <div class="float-left text-center" style="width: 10%">-</div>
                        <div class="float-left" style="width: 45%">
                          <input type="number" class="form-control" v-model="formSearch.toPrice"/>
                        </div>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter5 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.floor") }}
                      <div class="float-right">{{ filterFloor.filter((value) => value.checked == true).length > 0 ? filterFloor.filter((value) => value.checked == true).length : ""}}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter5" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterFloor" :key="`${i}`" >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter6 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.area") }}
                      <div class="float-right"><i class="fas fa-caret-down"></i></div>
                    </b-button>
                    <b-collapse id="filter6" class="mt-2">
                      <b-card>
                        <div class="float-left w-100 text-center"><b>{{ $t("pages.area_s") }}</b></div>
                        <div class="float-left" style="width: 45%">
                          <div class="text-center">น้อยสุด</div>
                          <input class="form-control" v-model="formSearch.fromArea"/>
                        </div>
                        <div class="float-left px-2 text-center" style="width: 10%; padding-top: 30px;">{{ $t("pages.to") }}</div>
                        <div class="float-left" style="width: 45%">
                          <div class="text-center">มากสุด</div>
                          <input class="form-control" v-model="formSearch.toArea"/>
                        </div>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter7 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.facing") }}
                      <div class="float-right">{{ filterFacing.filter((value) => value.checked == true).length > 0 ? filterFacing.filter((value) => value.checked == true).length : ""}}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter7" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterFacing" :key="`${i}`" >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter8 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.roomAmenities") }}
                      <div class="float-right">{{ filterRoomAmenities.filter((value) => value.checked == true).length > 0 ? filterRoomAmenities.filter((value) => value.checked == true).length : ""}}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter8" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterRoomAmenities" :key="`${i}`" >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                      </b-card>
                    </b-collapse>

                    <b-button v-b-toggle.filter9 size="sm" variant="primary" class="w-100 text-left mt-2">
                      {{ $t("pages.projectFacilities") }}
                      <div class="float-right">{{ filterProjectFacilities.filter((value) => value.checked == true).length > 0 ? filterProjectFacilities.filter((value) => value.checked == true).length : ""}}<i class="fas fa-caret-down ml-3"></i></div>
                    </b-button>
                    <b-collapse id="filter9" class="mt-2">
                      <b-card>
                        <label class="container-checkbox" v-for="(item, i) in filterProjectFacilities" :key="`${i}`" >
                        {{ item["listName_" + $i18n.locale] }}
                        <input type="checkbox" v-model="item.checked" />
                        <span class="checkmark"></span>
                      </label>
                      </b-card>
                    </b-collapse>
                    <button class="btn btn-primary mt-3 w-100" type="submit">{{ $t("button.search") }}</button>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
    <section class="py-4">
      <div class="container">
        <div class="row">
          <div class="col-12 text-right mb-2 mb-lg-3">
            <div class="float-left">
              <h6 class="mb-0">
                <b v-if="propList.length > 0"
                  >{{ propList.length }} {{ $t("pages.unitForRent") }}</b
                >
                <b v-if="propList.length == 0">{{ $t("pages.noUnit") }}</b>
              </h6>
            </div>
            <div class="d-none d-lg-block">
              <div class="btn-group float-right" role="group">
                <button
                  class="btn-grid py-1"
                  v-bind:class="{ active: !grid }"
                  @click="changeGrid(false)"
                >
                  <i class="fas fa-th"></i>
                </button>
                <button
                  class="btn-grid"
                  v-bind:class="{ active: grid }"
                  @click="changeGrid(true)"
                >
                  <i class="fas fa-list"></i>
                </button>
              </div>
            </div>
            <div
              class="field-search float-right mr-3 d-none d-lg-block"
              style="width: 200px"
            >
              <div class="float-left">
                <b>{{ $t("pages.sortOrder") }}</b>
              </div>
              <div class="float-right">
                <div class="d-inline">
                  <img src="./../../assets/images/icon/sort.png" width="25px" />
                </div>
              </div>
              <div class="block-dropdown">
                <div class="field-search-dropdown text-left">
                  <div
                    class="border-bottom pb-2 mb-2"
                    @click="searchProp(item.code)"
                    v-for="(item, i) in sortOrder"
                    :key="`sort-${i}`"
                  >
                    {{ item["name_" + $i18n.locale] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3 mb-lg-0">
            <div
              class="field-search float-left mr-3 d-block d-lg-none"
              style="width: 200px"
            >
              <div class="float-left">
                <b>{{ $t("pages.sortOrder") }}</b>
              </div>
              <div class="float-right">
                <div class="d-inline">
                  <img src="./../../assets/images/icon/sort.png" width="25px" />
                </div>
              </div>
              <div class="block-dropdown">
                <div class="field-search-dropdown text-left">
                  <div
                    class="border-bottom pb-2 mb-2"
                    @click="searchProp(item.code)"
                    v-for="(item, i) in sortOrder"
                    :key="`sort-${i}`"
                  >
                    {{ item["name_" + $i18n.locale] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-block d-lg-none">
              <div class="btn-group float-right" role="group">
                <button
                  class="btn-grid py-1"
                  v-bind:class="{ active: !grid }"
                  @click="changeGrid(false)"
                >
                  <i class="fas fa-th"></i>
                </button>
                <button
                  class="btn-grid"
                  v-bind:class="{ active: grid }"
                  @click="changeGrid(true)"
                >
                  <i class="fas fa-list"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 col-lg-4"
            v-bind:class="{ 'd-none': grid }"
            v-for="(item, i) in propList"
            :key="i"
          >
            <div class="border w-100 float-left mb-4">
              <img
                :src="item.photoFeature"
                class="w-100"
                style="z-index: 1"
                height="260"
                @error="onImageLoadFailure"
              />
              <div class="prohot">HOT DEAL</div>
              <div class="card-body w-100 float-left">
                <h6>
                  <b>
                    {{ item["projectName_" + $i18n.locale] }}
                    <br />
                    {{ $t("pages.roomNo") }} : {{ item.roomNo }}
                  </b>
                </h6>
                <div class="card-text">
                  <div class="fs-15" v-if="item['zone_' + $i18n.locale]">
                    <img
                      src="./../../assets/images/icon/marker.png"
                      class="mr-1"
                    />
                    {{ truncate(item["zone_" + $i18n.locale]) }}
                  </div>
                  <div class="fs-15">
                    <div>
                      {{ $t("pages.floor") }} {{ item.floorLevel }} |
                      {{ $t("pages.building") }} {{ item.building }}
                    </div>
                    <div class="d-inline">{{ $t("pages.roomAmenities") }}</div>
                    <div class="box-tooltip ml-2">
                      <img
                        src="./../../assets/images/icon/i-blue.png"
                        :id="'desktop' + item.propID"
                      />
                      <b-tooltip
                        :target="'desktop' + item.propID"
                        triggers="hover"
                      >
                        <div
                          v-for="(roomAmenities, i) in convertToArray(
                            item['roomAmenities_' + $i18n.locale]
                          )"
                          :key="i"
                        >
                          • {{ roomAmenities }}
                        </div>
                      </b-tooltip>
                    </div>
                    <div class="d-block d-md-none">
                      <b>{{ item.priceRental | numFormat }}</b>
                      <small>{{ $t("pages.bahtMonth") }}</small>
                    </div>
                  </div>
                  <div class="border-top mt-3 pt-2">
                    <div class="float-left">
                      <div class="facility-section">
                        <div class="facility-item border-right pr-2">
                          <img
                            src="./../../assets/images/bed.png"
                            class="mr-2"
                            width="22"
                          />
                          {{ item.bedRoom }}
                        </div>
                        <div class="facility-item border-right pr-2">
                          <img
                            src="./../../assets/images/bathroom.png"
                            class="mr-2"
                            width="22"
                          />
                          {{ item.bathRoom }}
                        </div>
                        <div class="facility-item">
                          <b class="pr-1">{{ item.floorArea }}</b>
                          {{ $t("pages.sqm") }}
                        </div>
                      </div>
                    </div>
                    <div class="float-right d-none d-lg-block">
                      <b>{{ item.priceRental | numFormat }}</b>
                      <br />
                      <p
                        class="position-relative mb-0 text-right"
                        style="font-size: 12px; margin-top: -3px"
                      >
                        {{ $t("pages.bahtMonth") }}
                      </p>
                    </div>
                    <div class="float-left w-100">
                      <router-link :to="'/unit-detail/' + item.propID">
                        <div class="mt-3 border-fac d-inline-block fs-15">
                          <b>{{ $t("pages.seeDetail") }}</b>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3" v-bind:class="{ 'd-none': !grid }">
            <div class="d-none d-md-block w-100">
              <table class="table table-bordered table-vertical-middle">
                <tbody>
                  <tr v-for="(item, i) in propList" :key="`a-${i}`">
                    <td width="25%" class="p-0">
                      <img
                        :src="item.photoFeature"
                        class="w-100"
                        style="z-index: 1"
                        height="200"
                        @error="onImageLoadFailure"
                      />
                    </td>
                    <td>
                      <h6>
                        <b>{{ item["projectName_" + $i18n.locale] }}</b>
                      </h6>
                      <div>
                        <b>{{ $t("pages.roomNo") }} : {{ item.roomNo }}</b>
                      </div>
                      <div class="pb-2" v-if="item['zone_' + $i18n.locale]">
                        <small>
                          <img
                            src="./../../assets/images/icon/marker.png"
                            class="mr-1"
                          />
                          {{ convertLocal(item["zone_" + $i18n.locale]) }}
                        </small>
                      </div>
                      <div class="prohot-detail ml-3">HOT DEAL</div>
                    </td>
                    <td class="text-center" width="8%">
                      <div class="mb-2">
                        <i class="sprite icon-bed mr-2"></i>
                        {{ item.bedRoom }}
                      </div>
                      <i class="sprite icon-bath mr-2"></i>
                      {{ item.bathRoom }}
                    </td>
                    <td class="text-center pt-3">
                      <b class="pr-1">{{ item.floorArea }}</b>
                      <div>{{ $t("pages.sqm") }}</div>
                    </td>
                    <td class="text-left" width="8%">
                      <div class="mb-2">
                        {{ $t("pages.floor") }} :
                        {{ item.floorLevel }}
                      </div>
                      <div>
                        {{ $t("pages.building") }} :
                        {{ item.building }}
                      </div>
                    </td>
                    <td class="text-center" width="10%">
                      <b>{{ item.priceRental | numFormat }}</b>
                      <div class="mb-2" width="7%">
                        <span class="fs-14">{{ $t("pages.bahtMonth") }}</span>
                      </div>
                    </td>
                    <td class="text-center" width="15%">
                      <div>{{ $t("pages.roomAmenities_1") }}</div>
                      <div>{{ $t("pages.roomAmenities_2") }}</div>
                      <img
                        src="./../../assets/images/icon/i-blue.png"
                        :id="'desktopGrid' + item.propID"
                      />
                      <b-tooltip
                        :target="'desktopGrid' + item.propID"
                        triggers="hover"
                      >
                        <div
                          v-for="(roomAmenities, i) in convertToArray(
                            item['roomAmenities_' + $i18n.locale]
                          )"
                          :key="i"
                        >
                          • {{ roomAmenities }}
                        </div>
                      </b-tooltip>
                    </td>
                    <td class="text-center">
                      <router-link :to="'/unit-detail/' + item.propID">
                        <div class="border-fac fs-15">
                          <b>{{ $t("pages.seeDetail") }}</b>
                        </div>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-block d-md-none w-100">
              <table
                class="table table-bordered table-vertical-middle"
                v-for="(item, i) in propList"
                :key="`b-${i}`"
              >
                <tbody>
                  <tr>
                    <td class="align-top" colspan="2">
                      <div class="float-left" style="width: 35%">
                        <img
                          :src="item.photoFeature"
                          style="z-index: 1"
                          class="w-100"
                          @error="onImageLoadFailure"
                        />
                      </div>
                      <div class="float-left pl-3" style="width: 65%">
                        <div class="prohot-detail mb-3">HOT DEAL</div>
                        <h6>
                          <b>
                            {{ item.projectName_TH }}
                            <br />
                            {{ $t("pages.roomNo") }} : {{ item.roomNo }}
                          </b>
                        </h6>
                        <div class="pb-2" v-if="item['zone_' + $i18n.locale]">
                          <img
                            src="./../../assets/images/icon/marker.png"
                            class="mr-1"
                          />
                          {{ item["zone_" + $i18n.locale] }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" class="text-center">
                      <i class="sprite icon-bed mr-2"></i>
                      <span class="mr-3">{{ item.bedRoom }}</span>
                      <i class="sprite icon-bath mr-2"></i>
                      {{ item.bathRoom }}
                    </td>
                    <td class="text-center" width="50%">
                      <b>{{ item.floorArea }}</b>
                      {{ $t("pages.sqm") }}
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" class="text-center">
                      {{ $t("pages.floor") }} {{ item.floorLevel }} |
                      {{ $t("pages.building") }} {{ item.building }}
                    </td>
                    <td class="text-center" width="50%">
                      <b>{{ item.priceRental | numFormat }}</b>
                      <br />
                      {{ $t("pages.bahtMonth") }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div class="d-inline">
                        {{ $t("pages.roomAmenities") }}
                      </div>
                      <div class="box-tooltip ml-2">
                        <img
                          src="./../../assets/images/icon/i-blue.png"
                          :id="'mobileGrid' + item.propID"
                        />
                        <b-tooltip
                          :target="'mobileGrid' + item.propID"
                          triggers="hover"
                        >
                          <div
                            v-for="(roomAmenities, i) in convertToArray(
                              item['roomAmenities_' + $i18n.locale]
                            )"
                            :key="i"
                          >
                            •
                            {{ roomAmenities }}
                          </div>
                        </b-tooltip>
                      </div>
                      <div class="float-right">
                        <router-link :to="'/unit-detail/' + item.propID">
                          <div class="border-fac fs-15">
                            <b>{{ $t("pages.seeDetail") }}</b>
                          </div>
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div class="col-12 text-center py-lg-5">
            <b>ดูทั้งหมด</b> <i class="fas fa-long-arrow-alt-down"></i>
          </div>-->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      grid: false,
      extraUnit: [],
      filterProjectName: [],
      filterZone: [],
      roomType: [],
      propList: [],
      propListLength: 0,
      formSearch: {
        projectNameTH: "",
        zoneTH: "",
        fromPrice: "",
        toPrice: "",
        price: "0-0",
        fromArea: "",
        toArea: "",
      },
      sortOrder: [
        {
          code: "FloorLevel ASC",
          name_TH: "ชั้น (ล่าง-บน)",
          name_EN: "Floor Level (Ascending)",
        },
        {
          code: "FloorLevel DESC",
          name_TH: "ชั้น (บน-ล่าง)",
          name_EN: "Floor Level (Descending)",
        },
        {
          code: "FloorArea ASC",
          name_TH: "ขนาดห้อง (เล็ก-ใหญ่)",
          name_EN: "Floor Area (Ascending)",
        },
        {
          code: "FloorArea DESC",
          name_TH: "ขนาดห้อง (ใหญ่-เล็ก)",
          name_EN: "Floor Area (Descending)",
        },
        {
          code: "PriceRental ASC",
          name_TH: "ราคาเช่า (น้อย-มาก)",
          name_EN: "Price Rental (Ascending)",
        },
        {
          code: "PriceRental DESC",
          name_TH: "ราคาเช่า (มาก-น้อย)",
          name_EN: "Price Rental (Descending)",
        },
      ],
      filterFloor: [],
      filterRoomArea: [],
      filterFacing: [],
      filterRoomAmenities: [],
      filterProjectFacilities: [],
      getPriceList: [],
      dataFilterZone: [],
      dataFilterProjectName: [],
      dataFillterroomType: [], //pisit.i added 2020-11-18
    };
  },
  methods: {
    objAssign(data) {
      for (const item of data) {
        item.checked = false;
      }
      return data;
    },
    changeGrid(flag) {
      this.grid = flag;
    },
    getExtraUnit() {
      this.$http
        .get(this.$app.baseURL + this.$path.getExtra)
        .then((res) => (this.extraUnit = res.data)).data;
    },
    getFilter() {
      this.$http
        .get(this.$app.baseURL + this.$path.getFilterProjectName)
        .then(
          (res) => (this.filterProjectName = this.objAssign(res.data.data))
        );
      this.$http
        .get(this.$app.baseURL + this.$path.getFilterZone)
        .then((res) => (this.filterZone = this.objAssign(res.data.data)));
      this.$http
        .get(this.$app.baseURL + this.$path.getRoomType)
        .then((res) => (this.roomType = this.objAssign(res.data.data)));
      this.$http
        .get(this.$app.baseURL + this.$path.filterFacing)
        .then((res) => (this.filterFacing = this.objAssign(res.data.data)));
      this.$http
        .get(this.$app.baseURL + this.$path.filterRoomAmenities)
        .then(
          (res) => (this.filterRoomAmenities = this.objAssign(res.data.data))
        );
      this.$http
        .get(this.$app.baseURL + this.$path.filterProjectFacilities)
        .then(
          (res) =>
            (this.filterProjectFacilities = this.objAssign(res.data.data))
        );
      this.$http
        .get(this.$app.baseURL + this.$path.getPriceList)
        .then((res) => (this.getPriceList = res.data.data));
      this.$http
        .get(this.$app.baseURL + this.$path.getFloorList)
        .then((res) => (this.filterFloor = this.objAssign(res.data.data)));
    },
    searchProp(sortOrder) {
      const userInfo = JSON.parse(localStorage.getItem("agenthub-info"));
      let loading = this.$loading.show();
      const formData = new FormData();
      // const splitPrice = this.formSearch.price.split("-");
      formData.append(
        "projectCode",
        this.filterCheckbox(this.filterProjectName, "project_Code")
      );
      formData.append(
        "zoneCode",
        this.filterCheckbox(this.filterZone, "zone_Code")
      );
      formData.append(
        "listRoomType",
        this.filterCheckbox(this.roomType, "list_Code")
      );
      // formData.append("fromPrice", splitPrice[0]);
      // formData.append("toPrice", splitPrice[1]);
      formData.append(
        "fromPrice",
        this.formSearch.fromPrice ? this.formSearch.fromPrice : 0
      );
      formData.append(
        "toPrice",
        this.formSearch.toPrice ? this.formSearch.toPrice : 0
      );
      formData.append(
        "fromFloor",
        this.filterCheckbox(this.filterFloor, "list_Code")
      );
      formData.append("toFloor", "");
      formData.append("fromArea", this.formSearch.fromArea);
      formData.append("toArea", this.formSearch.toArea);
      formData.append(
        "facingList",
        this.filterCheckbox(this.filterFacing, "list_Code")
      );
      formData.append(
        "projectFactilityList",
        this.filterCheckbox(this.filterProjectFacilities, "list_Code")
      );
      formData.append(
        "roomAmenityList",
        this.filterCheckbox(this.filterRoomAmenities, "list_Code")
      );
      formData.append("pageNo", 1);
      formData.append("pageSize", 9999999);
      formData.append("sortOrder", sortOrder ? sortOrder : "PriceRental DESC");
      formData.append("userID", userInfo ? userInfo.userID : 0);
      this.propList = [];
      this.$http.post(this.$app.baseURL + this.$path.searchProp, formData).then(
        (res) => {
          loading.hide();
          this.propList = res.data.data;
          //this.resetForm(); //pisit.i add comment reset form 2020-11-18
        },
        () => {
          loading.hide();
          this.propListLength = 0;
          this.propList = [];
          //this.resetForm(); //pisit.i add comment reset form 2020-11-18
        }
      );
    },
    filterCheckbox(data, key) {
      let filterCheckbox = [];
      for (const item of data) {
        if (item.checked) {
          filterCheckbox.push(item[key]);
        }
      }
      filterCheckbox = filterCheckbox.join("|");
      return filterCheckbox;
    },
    getFilterProjectName(value, checked) {
      if (checked) {
        this.dataFilterZone.push(value);
        this.dataFilterProjectName = []; //pisit.i added 2020-11-18
      } else {
        const findIndex = this.dataFilterZone.findIndex(
          (resault) => resault == value
        );
        this.dataFilterZone.splice(findIndex, 1);
        this.dataFilterProjectName = []; //pisit.i added 2020-11-18
      }
      const req = this.dataFilterZone.join("|");
      this.$http
        .get(this.$app.baseURL + this.$path.getFilterProjectName + "/" + req)
        .then(
          (res) => (this.filterProjectName = this.objAssign(res.data.data))
        );
    },
    getFilterZone(value, checked) {
      if (checked) {
        this.dataFilterProjectName.push(value);
      } else {
        const findIndex = this.dataFilterProjectName.findIndex(
          (resault) => resault == value
        );
        this.dataFilterProjectName.splice(findIndex, 1);
      }
      //pisit.i added 2020-11-18 comment
      //const req = this.dataFilterProjectName.join("|");
      //this.$http
      //  .get(this.$app.baseURL + this.$path.getFilterZone + "/" + req)
      //  .then((res) => (this.filterZone = this.objAssign(res.data.data)));
    },

    getFilterRoomType(value, checked) {
      if (checked) {
        this.dataFillterroomType.push(value);
      } else {
        const findIndex = this.dataFillterroomType.findIndex(
          (resault) => resault == value
        );
        this.dataFillterroomType.splice(findIndex, 1);
      }
    },

    convertToArray(value) {
      return value ? value.split(",") : null;
    },
    convertLocal(value) {
      let local = value;
      if (local != null && local.length >= 25) {
        local = local.substring(0, 25) + "...";
      }

      return local;
    },
    resetForm() {
      this.formSearch = {
        projectNameTH: "",
        zoneTH: "",
        fromPrice: "",
        toPrice: "",
        price: "0-0",
        fromArea: "",
        toArea: "",
      };
      setTimeout(() => {
        this.getFilter();
      }, 200);
    },
    onImageLoadFailure(event) {
      event.target.src = require("./../../assets/images/default.png");
    },
  },
  mounted: function () {
    this.getExtraUnit();
    this.getFilter();
    this.searchProp();
  },
};
</script>

<style scoped>
.card-body {
  padding: 10px;
}
/* .col-lg-4 {
    padding-left: 25px;
    padding-right: 25px;
  } */
</style>